import type { FC } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

interface Props {
  onClick: () => void
  employeeId: number
  developmentMode: boolean
}

const Actions: FC<Props> = ({ employeeId, developmentMode, onClick }) => {
  const { navigation } = useNavigation()

  const employeePath = navigation.employees.id.fullPath({
    id: employeeId,
  })

  return (
    <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
      <Button.Router
        to={{
          pathname: employeePath,
          search: developmentMode
            ? new URLSearchParams({
                developmentMode: developmentMode.toString(),
              }).toString()
            : '',
        }}
        onClick={onClick}
        type="secondary"
        aria-label="Access review"
        iconName="arrow-right"
      />
    </Box>
  )
}

export default Actions
